<template>
<v-list-tile two-line @click="makeReturn">
	<v-list-tile-action>
		<v-icon small>fa-exchange-alt</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Return</v-list-tile-title>
		<v-list-tile-sub-title small>Create a return journey based on this one</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionReturn",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),
	},

	methods: {
		makeReturn () {
			// TODO
			console.log("RETURN ACTION HANDLER");
		}
	}
};

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionReturn.vue